import take from "lodash/take";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { articleAuthorDetailsContent$key } from "~/queries/__generated__/articleAuthorDetailsContent.graphql";

import { AuthorCard } from "./author-card";
import type { AuthorCardsContainerProps } from "./styles";
import { AuthorCardsContainer } from "./styles";

export type Props = {
  className?: string;
  firstNthAuthor?: number;
  reference: articleAuthorDetailsContent$key;
  variant?: AuthorCardsContainerProps["$variant"];
};

export const ArticleAuthorsDetails: FunctionComponent<Props> = ({
  className,
  firstNthAuthor,
  reference: reference_,
  variant = "light",
}) => {
  const content = useFragment(
    graphql`
      fragment articleAuthorDetailsContent on Content {
        authors {
          entityId
          ...authorCardAuthor
          bio
        }
      }
    `,
    reference_,
  );

  if (!content) return null;
  let authors = (firstNthAuthor ? take(content.authors, firstNthAuthor) : content.authors) ?? [];
  if (authors.length === 0) return null;

  if (variant !== "magazines-style") {
    authors = authors?.filter(author => author?.bio);
    const validAuthorsLength = authors?.length ?? 0;
    if (validAuthorsLength === 0) return null;
  }

  return (
    <AuthorCardsContainer $variant={variant} className={className}>
      {authors?.map(
        author =>
          author && <AuthorCard key={author.entityId} reference={author} variant={variant} />,
      )}
    </AuthorCardsContainer>
  );
};

ArticleAuthorsDetails.displayName = "ArticleAuthorsDetails";
